import React, { useState } from "react";
import Objective from "./Objective";
import Plotting from "./plotting/Plotting";
import Computing from "./computing/Computing";
import Heading from "./heading/Heading";

/**
 * Main D-Shape Tunnel Component
 * Manages workflow steps: objective selection, plotting, computing, and heading
 */
const Dshape = (props) => {
  const [isStep, setStep] = useState("objective");

  return isStep === "objective" ? (
    <Objective setstep={setStep} />
  ) : isStep === "orientation" ? (
    <Plotting setstep={setStep} />
  ) : isStep === "computing" ? (
    <Computing setstep={setStep} />
  ) : (
    <Heading />
  );
};

export default Dshape;






